import React from 'react'

/**
 * Selection outline for the admin editor preview. Drawn as an overlay rather
 * than a border or outline on the section itself because section content
 * (full-bleed carousels, inline PDPs) paints an opaque background across the
 * whole section box and hides the section's own box decorations.
 *
 * Requires a positioned parent.
 */
export const EditorSectionHighlight: React.FC = () => (
    <div
        aria-hidden
        style={{
            position: 'absolute',
            inset: 0,
            zIndex: 9999,
            border: '2px solid rgba(99, 102, 241, 0.95)',
            borderRadius: 'inherit',
            pointerEvents: 'none',
        }}
    />
)
